import Vue from 'vue'
import BraveLink from 'brave-routing/components/brave-link'
import BraveForm from 'brave-form/components/brave-form'
import BraveModal from 'brave-routing/components/brave-modal'

export default function globalComponentInitialization() {
  Vue.component('brave-link', BraveLink)
  Vue.component('brave-form', BraveForm)
  Vue.component('brave-modal', BraveModal)
}


// WEBPACK FOOTER //
// ./lib/brave-vue/globalComponentInitialization.js